define([
    "./VerifyComponentProperty"
], function (VerifyComponentProperty) {
    return ({
        showDescription: new VerifyComponentProperty({
            type: "boolean",
            defaultValue: true,
            notInAction: true,
            required: false
        })
    });
});
